import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ConnectionCount } from "src/types/apps";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { GetConnectionsCount } from "./NetTypes";

export async function getConnectionsCountRequest(orgId: string, appId: string, product?: string) {
	return await apiClient
		.get(API.QUERY.ORGANIZATIONS.APPS.CONNECTIONS_COUNT(orgId, appId, product))
		.then((res) => res.data);
}

export async function getConnectionsHistoryRequest(
	orgId: string,
	appId: string,
	period: string = "7D",
	product?: string
) {
	return await apiClient
		.get(API.QUERY.ORGANIZATIONS.APPS.CONNECTIONS_HISTORY(orgId, appId, period, product))
		.then((res) => res.data);
}

export function useGetAppConnectionsCount(orgId: string, appId: string, product?: string) {
	return useQuery<GetConnectionsCount, AxiosError>({
		queryKey: [appId, product ? `${product}Count` : "allCount"],
		queryFn: () => getConnectionsCountRequest(orgId, appId, product),
		enabled: !!orgId && !!appId,
		initialData: { variation: { mtd: 0, ytd: 0, day: 0 }, current: [] }
	});
}

export function useGetAppConnectionsHistory(
	orgId: string,
	appId: string,
	period: string,
	product?: string
) {
	const productId = product ? `${product}History` : "allHistory";
	return useQuery<ConnectionCount[], AxiosError>({
		queryKey: [appId, productId, period],
		queryFn: () => getConnectionsHistoryRequest(orgId, appId, period, period),
		enabled: !!appId && !!orgId
	});
}
